import React, { useState } from "react";
import styled from "styled-components";
import RightNav from "./RightNav";

function StyledBurger() {
	const [open, setOpen] = useState(false);
	return (
		<>
			<Hamburger open={open} onClick={() => setOpen(!open)}>
				<div />
				<div />
				<div />
			</Hamburger>
			<RightNav open={open} />
		</>
	);
}
const Hamburger = styled.div`
	height: 2rem;
	width: 2rem;
	position: fixed;
	top: 15px;
	right: 20px;
	cursor: pointer;
	z-index: 200;
	display: none;
	@media (max-width: 890px) {
		display: flex;
		justify-content: space-around;
		flex-flow: column nowrap;
	}
	div {
		width: 2.1rem;
		height: 0.25rem;
		border-radius: 2px;
		background-color: ${({ open }) => (open ? "rgb(0,218,247)" : "whitesmoke")};
		transform-origin: 1px;
		transition: all 0.3s linear;
		&:nth-child(1) {
			transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
		}
		&:nth-child(2) {
			transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
			opacity: ${({ open }) => (open ? 0 : 1)};
		}
		&:nth-child(3) {
			transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
		}
	}
`;
export default StyledBurger;
